export default __webpack_public_path__ + "static/media/main.bd247d83.png";